import { render, staticRenderFns } from "./indexSecond.vue?vue&type=template&id=0bdf55da&scoped=true&"
import script from "./indexSecond.vue?vue&type=script&lang=js&"
export * from "./indexSecond.vue?vue&type=script&lang=js&"
import style0 from "./indexSecond.vue?vue&type=style&index=0&id=0bdf55da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf55da",
  null
  
)

export default component.exports